<template>
    <div class="container">
      <div class="header-preview">
            <div class="logo-img"><img src="/static/img/main-logo.svg" class="logo" height="50" /></div>
            <div class="row" >
                <div class="col-sm-12 col-md-3 offset-md-1 text-center" >
                  <div >
                    <img v-lazy="userData.job_user.picture" class="rounded-circle img-fluid img-thumbnail img-style"  alt="...">
                  </div>
                    
                </div>
                <div class="col-sm-12 col-md-7 header-name">
         
                        <h2>{{ userData.job_user.name }}</h2>
                        <h3 class="text-beneat" >BENEAT RECRUTING SERVICE</h3>
                        <h4 v-if="userData.job_user.professional" >{{ userData.job_user.professional.short_description }}</h4>
                        <h4 v-else >{{ userData.job_user.introduce }}</h4>
                        
                 
                </div>
            </div>
        </div>
        <div class="row body-preview no-gutters">
            <div class="col-sm-12 col-md-8 pr-2 text-left">
                <div>
                    <p class="body-topic" v-if="userData.job_user.professional" >Profile</p>
                    <p class="detail-topic description-indent" v-if="userData.job_user.professional" >{{ userData.job_user.professional.description }} </p>
                </div>
               <div>
                    <p class="body-topic" v-if="userData.job_user.working_experience">Exprience</p>
                    <p class="detail-topic description-indent" v-if="userData.job_user.working_experience" >{{ userData.job_user.working_experience ? userData.job_user.working_experience : '' }} </p>
                </div>
                 <div>
                    <p class="body-topic" v-if="userData.job_user.job_user_job_skills.length > 0">Skill</p>
                    <div v-if="userData.job_user.job_user_job_skills.length > 0" v-for="itemUserJob,index in userData.job_user.job_user_job_skills" :key="index">
                        <p class="description-indent" v-for="item,i in userData.job_skills" :key="i" v-if="itemUserJob.job_skill_id == item.id" >
                           {{ item.name }}
                        </p>
                    </div>
                </div>
            </div>
            <div class="col-sm-12 col-md-4 m-0">
                <div class="detail" v-if="userData.job_user.professional" >
                    <p v-if="userData.job_user.professional">ชื่อ-สกุล {{ userData.job_user.name }}</p>
                    <p v-if="userData.job_user.professional" >อายุ : {{ userData.job_user.professional.birthday ? userData.job_user.professional.birthday : '' | age }}</p>
                    <template  v-if="userData.job_user.job_user_languages.length > 0">
                       <p>ภาษา :</p>
                        <div v-for="(itemUserLang,index) in userData.job_user.job_user_languages" :key="index">
                          <p class="description-indent" v-for="(item,i) in userData.job_languages" :key="i" v-if="itemUserLang.language_id == item.id" >
                           {{ item.native }}
                          </p>
                        </div>
                    </template>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
export default {
  data () {
    return {
      userData: null
    }
  },
  created () {
    this.fetchProfessional()
  },
  filters: {
    age: value => {
      if (!value) return ''
      let year = value.split('-')[0]
      const today = new Date()
      const age = today.getFullYear() - year
      return age + ' ปี'
    },
    skill: value => {
      if (!value) return ''
      return value
    },
    language: value => {
      if (!value) return ''
      return value
    }
  },
  methods: {
    async fetchProfessional () {
      const { data } = await axios.get('/job-users/user/' + this.$route.params.id, {params: {sha: this.$route.query.sha}})
      if (!data.error) {
        this.userData = data
      }
    }

  }
}
</script>

<style scoped>
@media screen and (min-width: 400px) {
  body {
    background-color: lightgreen;
  }
}
.container {
    background-color: #fff;
    max-width: 900px;
    padding-top: 10px;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    border-radius: 2rem;
    box-shadow: 0px 1rem 2.5rem rgba(0,0,0,0.5);
}
.text-beneat {
  color: white;
  text-shadow: 4px 2px 8px #42aafa;
}
.header-preview {
    background-color:#c3eeff;
    margin-bottom: 20px;
    border-radius: 15px 50px;
}

.header-name {
    padding-top: 40px;
    margin-bottom: 15px;
}
.logo-img {
    text-align: end;
    margin: 10px;
    padding-top: 10px;
    padding-right: 10px;
}
.header-picture {
    background-color: #fff;
    padding: 2px;
    text-align: center;
    max-width: max-content;
    max-height: max-content;
}
.img-style {
 box-shadow: 0px 1rem 1.5rem rgba(0,0,0,0.5);
 max-height: 200px;
}
.body-preview {
    padding: 15px 0 15px 0px;
    margin: 0 !important;
}
.body-topic {
    background-color: #c3eeff;
    border-radius: 25px;
    max-width: 200px;
    padding: 5px;
    padding-left: 15px;
    text-align: center;
}
.detail-topic {
    letter-spacing: 2px;
    text-align: justify;
}
.description-indent {
   text-indent: 50px;
}

.detail {
    background-color: rgb(195 238 255);
    border-top-left-radius: 20px;
    border-bottom-right-radius: 20px;
    height: 100%;
    padding: 20px;
    min-width: 285px;
}
</style>



// WEBPACK FOOTER //
// src/components/jobPost/Profile.vue